import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="AI Engineering by Chip Huyen"
        desc="Building real-world AI products with large language models"
        image="/images/books/ai-engineering.jpg"
        pageType="book"
        author="Chip Huyen"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/ai-engineering.jpg"
                width="400"
                className="shadow-lg"
              />

            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                AI Engineering
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Chip Huyen</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Join us in exploring Chip Huyen's groundbreaking book on AI Engineering. This comprehensive
                guide delves into the practical aspects of building and deploying AI systems at scale. Whether
                you're a seasoned engineer looking to transition into AI or a curious developer wanting to
                understand how modern AI systems are built, this book offers invaluable insights into the
                intersection of software engineering and artificial intelligence. Together, we'll discuss
                real-world challenges, best practices, and the future of AI engineering.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Don't miss this opportunity to learn and engage with fellow engineers passionate about AI development.
              </p>
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
